import React from "react";
import { Box, Grid, TextField, FormControl, FormControlLabel, RadioGroup, Radio, Typography } from "@mui/material";
import RangeSlider from "../../RangeSlider/Slider";
import FileUpload from "./ FileUpload";
import { grayOutlinedTextFieldStyle } from "@/common/TextFieldStyles";

const StepContent = ({
  step,
  questions = [],
  selectedOptions,
  onSelect,
  income,
  setIncome,
  purchasePrice,
  setPurchasePrice,
  deposite,
  setDeposite,
  expenses,
  setExpenses,
  formData = {},
  onInputChange,
  errors = {},
  selectedFiles,
  handleRemoveFile,
  getRootProps,
  getInputProps,
  isDragActive,
}) => {
  // Step 0 & 1: Radio-based questions
  if ((step === 0 || step === 1) && questions.length > 0) {
    return (
      <Box sx={{ ml:5 }}>
        {questions.map((q, qIndex) => (
          <FormControl key={qIndex} component="fieldset"  fullWidth>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, }}>
              {q.question}
            </Typography>
            <RadioGroup
              value={selectedOptions[`step${step}-q${qIndex}`] ?? ""}
              onChange={(e) => onSelect(qIndex, parseInt(e.target.value))}
            >
        {q.options.map((option, oIndex) => (
          <FormControlLabel
            key={oIndex}
            value={oIndex}
            control={
              <Radio
                size="small"
                sx={{
                  p: { xs: 0.5, sm: 0.3, md: 0.4, lg:0.5, xl:1 }, 
                }}
              />
            }
            label={
              <Typography
                sx={{
                  fontSize: {
                    xs: '0.75rem',
                    sm: '0.8rem',
                    md: '0.85rem',
                    lg: '0.9rem',
                    xl: '1rem',
                  },
                }}
              >
                {option}
              </Typography>
            }
          />
        ))}
            </RadioGroup>
            {errors[`step${step}-q${qIndex}`] && (
              <Typography color="error" sx={{ fontSize: '0.45rem' }}>
                {errors[`step${step}-q${qIndex}`]}
              </Typography>
            )}
          </FormControl>
        ))}
      </Box>
    );
  }

  // Step 2: Sliders
  if (step === 2) {
    return (
      <Box sx={{ mt: 3 }}>
        <RangeSlider
          income={income}
          setIncome={setIncome}
          purchasePrice={purchasePrice}
          setPurchasePrice={setPurchasePrice}
          deposite={deposite}
          setDeposite={setDeposite}
          expenses={expenses}
          setExpenses={setExpenses}
        />
      </Box>
    );
  }

  // Step 3: Form fields
  if (step === 3) {
    return (
      <Box sx={{ mt: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              name="firstName"
              label="First Name"
              value={formData.firstName}
              onChange={onInputChange}
              fullWidth
              error={!!errors.firstName}
              helperText={errors.firstName}
              size="small"
              sx={grayOutlinedTextFieldStyle}
              InputProps={{
                sx: {
                  height: 50, // customize height here
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="lastName"
              label="Last Name"
              value={formData.lastName}
              onChange={onInputChange}
              fullWidth
              error={!!errors.lastName}
              helperText={errors.lastName}
              size="small"
              sx={grayOutlinedTextFieldStyle}
              InputProps={{
                sx: {
                  height: 50, // customize height here
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="email"
              label="Email"
              value={formData.email}
              onChange={onInputChange}
              fullWidth
              error={!!errors.email}
              helperText={errors.email}
              size="small"
              sx={grayOutlinedTextFieldStyle}
              InputProps={{
                sx: {
                  height: 50, // customize height here
                },
              }}

            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="phone"
              label="Phone Number"
              value={formData.phone}
              onChange={onInputChange}
              fullWidth
              error={!!errors.phone}
              helperText={errors.phone}
              size="small"
              sx={grayOutlinedTextFieldStyle}
              InputProps={{
                sx: {
                  height: 50, // customize height here
                },
              }}
            />
          </Grid>
        </Grid>
        {/* — File upload area — */}
        <FileUpload
          selectedFiles={selectedFiles}
          handleRemoveFile={handleRemoveFile}
          getRootProps={getRootProps}
          getInputProps={getInputProps}
          isDragActive={isDragActive}
        />
      </Box>
    );
  }

  // Default return if step not matched
  return null;
};

export default StepContent;
